import React from "react";
import { useLang } from "../lib/lang-context";
import { LOGO_URL } from "../lib/i18n";
import { Phone, EnvelopeSimple, MapPin, Clock } from "@phosphor-icons/react";

export default function Contact() {
  const { t } = useLang();
  const items = [
    { Icon: Phone, label: t.contact.phone, key: "phone" },
    { Icon: EnvelopeSimple, label: t.contact.email, key: "email" },
    { Icon: MapPin, label: t.contact.address, key: "address" },
    { Icon: Clock, label: t.contact.hours, key: "hours" },
  ];

  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="py-24 md:py-32 bg-white dark:bg-zinc-950 border-t border-slate-200 dark:border-zinc-800"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-end mb-12">
          <div className="lg:col-span-7">
            <p className="text-xs tracking-[0.24em] uppercase font-bold text-[var(--icor-blue)] eyebrow-line">
              {t.contact.eyebrow}
            </p>
            <h2 className="font-display text-4xl md:text-5xl font-semibold tracking-tighter mt-5 text-[var(--icor-navy)] dark:text-white text-balance">
              {t.contact.title}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-slate-200 dark:bg-zinc-800 border border-slate-200 dark:border-zinc-800">
          {items.map(({ Icon, label, key }) => (
            <div
              key={key}
              className="bg-white dark:bg-zinc-950 p-7 hover:bg-slate-50 dark:hover:bg-zinc-900 transition-colors"
              data-testid={`contact-${key}`}
            >
              <Icon size={24} weight="duotone" color="var(--icor-blue)" />
              <div className="mt-4 text-sm text-slate-700 dark:text-zinc-300 leading-relaxed">
                {label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
